import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const predictionTournamentPostCardContent = style([
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
]);

export const showMoreButton = style([
  {
    marginTop: space.s16,
  },
]);
